import { EventEmitter, OnChanges, OnInit, TemplateRef } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { LocalStorageHelpers } from 'app/helpers';
import { DigitalCareerDaysService } from 'app/services/digital-career-days.service';
import { BsModalService } from 'ngx-bootstrap';
import * as moment from 'moment';
var ScheduleInterviewComponent = /** @class */ (function () {
    function ScheduleInterviewComponent(dcds, toasterService, localStorageHelper, modalService) {
        this.dcds = dcds;
        this.toasterService = toasterService;
        this.localStorageHelper = localStorageHelper;
        this.modalService = modalService;
        this.interview = null;
        this.applicationId = null;
        this.candidate = null;
        this.careerDayId = null;
        this.jobTitle = null;
        this.jobType = null;
        this.disabled = false;
        this.changes = new EventEmitter();
        this.invitationSent = false;
        this.completedAvailability = {
            user_completed_availability: false,
            team_completed_availability: false
        };
    }
    Object.defineProperty(ScheduleInterviewComponent.prototype, "canShow", {
        get: function () {
            return this.applicationId && this.careerDayId && this.candidate;
        },
        enumerable: true,
        configurable: true
    });
    ScheduleInterviewComponent.prototype.isFinished = function (date) {
        return moment().diff(date) > 0;
    };
    ScheduleInterviewComponent.prototype.ngOnInit = function () {
        // console.log(this.interview, this.applicationId, this.careerDayId, this.candidate);
        // console.log(this.jobType);
    };
    ScheduleInterviewComponent.prototype.ngOnChanges = function () {
        // console.log(this.interview, this.applicationId, this.careerDayId, this.candidate);
        // console.log(this.disabled);
    };
    ScheduleInterviewComponent.prototype.successToast = function (name, surname) {
        this.toasterService.pop('success', 'Success', "The interview request with " + name + " " + surname + " has been successfully completed");
    };
    ScheduleInterviewComponent.prototype.errorToast = function () {
        this.toasterService.pop('error', 'Error!', 'Please try again.');
    };
    ScheduleInterviewComponent.prototype.openModal = function (skipModal) {
        var _this = this;
        if (skipModal === void 0) { skipModal = false; }
        this.completedAvailability = {
            user_completed_availability: false,
            team_completed_availability: false
        };
        this.dcds.getAvailability(this.careerDayId).subscribe(function (response) {
            _this.completedAvailability = response;
            if (!skipModal) {
                _this.modalRef = _this.modalService.show(_this.templateRef, { 'class': 'modal-lg' });
            }
        }, function (error) {
            console.log(error);
        });
    };
    ScheduleInterviewComponent.prototype.scheduleInterview = function (withTeam) {
        var _this = this;
        if (withTeam === void 0) { withTeam = false; }
        var ob$ = this.dcds.postScheduleInterview(this.careerDayId, this.applicationId, {
            recruiters: withTeam ? [] : [JSON.parse(this.localStorageHelper.get('userData')).id]
            // ,employers_id: JSON.parse(this.localStorageHelper.get('userData')).Teams[0].employers_id
        });
        // FIX-ME only used for testing
        // ob$ = of(withTeam);
        ob$.subscribe(function () {
            // this.successToast(this.candidate.name, this.candidate.surname);
            // this.modalRef.hide();
            _this.changes.emit();
            _this.invitationSent = true;
        }, function (error) {
            _this.errorToast();
            console.log(error);
        });
    };
    return ScheduleInterviewComponent;
}());
export { ScheduleInterviewComponent };
